import { useState, useEffect, useMemo } from 'react'
import LoadingPage from '../../components/ui/LoadingPage'
import { useCompositions } from '../../hooks/useCompositions'
import Alert from '../../components/ui/Alert'
import CompositionSearch from '../../components/ui/CompositionSearch'
import { useLanguage } from '../../i18n/LanguageContext'

function BuildChampionGraph() {
  const { t } = useLanguage()
  const { data, imageMap, itemComponents, itemImageMap, loading, error } =
    useCompositions()

  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedTerm, setDebouncedTerm] = useState('')
  const [playStyleFilter, setPlayStyleFilter] = useState(null)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedTerm(searchTerm)
    }, 200)
    return () => clearTimeout(timer)
  }, [searchTerm])

  const filteredData = useMemo(() => {
    let entries = Object.values(data)
    if (debouncedTerm.length >= 2) {
      const term = debouncedTerm.toLowerCase()
      entries = entries.filter(
        (entry) =>
          entry.name.toLowerCase().includes(term) ||
          entry.champions.some((champ) =>
            champ.name.toLowerCase().includes(term),
          ),
      )
    }
    if (playStyleFilter && playStyleFilter.length > 0) {
      entries = entries.filter((entry) =>
        playStyleFilter.includes(entry.play_style),
      )
    }
    return entries
  }, [data, debouncedTerm, playStyleFilter])

  if (loading) return <LoadingPage />
  if (error) return <Alert type="error">{t('alert.loadError')}</Alert>

  return (
    <CompositionSearch
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      debouncedTerm={debouncedTerm}
      filteredData={filteredData}
      allComps={data}
      imageMap={imageMap}
      itemComponents={itemComponents}
      itemImageMap={itemImageMap}
      playStyleFilter={playStyleFilter}
      setPlayStyleFilter={setPlayStyleFilter}
    />
  )
}

export default BuildChampionGraph
